<template>
  <div class="serviceInventory-container">
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="api" theme="filled" />
          <span>端口映射台账</span>
        </a-space>
      </template>
      <span>端口映射台账包含云服务器、公网 IP等信息。</span>
    </a-page-header>

    <a-card :bordered="false" style="margin-bottom: 16px">
      <list-layout
        :getTableDataFunc="getTableDataFunc"
        :columnsAll="columnsAll"
        :columnDefaultSelected="columnDefaultSelected"
        :exportFunc="exportFunc"
        :toolsList="['setting', 'reload', 'leftTool', 'export']"
        :refresh="refresh"
      >
        <template #leftTool>
          <create-button
            v-permission="{action: 'base.inventory.create', effect: 'disabled'}"
            @click="$refs.inputDrawer.show()"
          ></create-button>
        </template>
        <template #rightTool>
          <upload-button
            v-permission="{action: 'base.inventory.update'}"
            @click="$refs.uploadModal.show()"
          ></upload-button>
        </template>

        <!-- 自定义列 -->
        <template #operation="{ slotProps }">
          <edit-button
            v-permission="{action: 'base.inventory.update', effect: 'disabled'}"
            @click="$refs.inputDrawer.show(slotProps.record.id)"
          ></edit-button>
          <delete-button
            v-permission="{action: 'base.inventory.delete', effect: 'disabled'}"
            @confirm="confirm(slotProps.record.id)"
          ></delete-button>
        </template>
      </list-layout>
    </a-card>

    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
    <upload-modal ref="uploadModal" @confirm="uploadConfirm"></upload-modal>
  </div>
</template>

<script>
import {
  getPortMapInventoryList,
  deletePortMapInventory,
  exportPortMapInventory
} from '@/api/inventory.js'
import ListLayout from '@/components/ListLayout.vue'
import CreateButton from '@/components/button/CreateButton.vue'
import InputDrawer from './modules/InputDrawer.vue'
import UploadButton from '@/components/button/UploadButton.vue'
import UploadModal from './modules/UploadModal.vue'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'

export default {
  name: 'PortMapInventory',
  components: {
    ListLayout,
    CreateButton,
    InputDrawer,
    UploadButton,
    UploadModal,
    DeleteButton,
    EditButton
  },
  data () {
    return {
      getTableDataFunc: getPortMapInventoryList,
      refresh: false,
      exportFunc: exportPortMapInventory,
      columnsAll: [
        {
          dataIndex: 'host.private_ip',
          title: '云主机内网 IP',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'host'
          }
        },
        {
          dataIndex: 'local_port',
          title: '本地端口',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'localPort'
          }
        },
        {
          dataIndex: 'protocol',
          title: '协议',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'protocol'
          }
        },
        {
          dataIndex: 'public_ip.ip_address',
          title: '公网 IP 地址',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'publicIp'
          }
        },
        {
          dataIndex: 'map_port',
          title: '映射端口',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'mapPort'
          }
        },
        {
          dataIndex: 'application_scenario',
          title: '应用场景',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'applicationScenario'
          }
        },
        {
          dataIndex: 'open_time',
          title: '开通时间',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'openTime'  
          }
        },
        {
          dataIndex: 'close_time',
          title: '关闭时间',
          width: 140, 
          ellipsis: true,
          scopedSlots: {
            customRender: 'closeTime'
          }
        },
        {
          dataIndex: 'remark',
          title: '备注',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'remark'  
          }
        }

      ],
      columnDefaultSelected: [
        'host.private_ip',
        'local_port',
        'protocol',
        'public_ip.ip_address',
        'map_port',
        'application_scenario',
        'open_time',
        'close_time',
        'remark'
      ]
    }
  },
  created () {
    // this.fetch()
  },
  methods: {
    async confirm (id = '') {
      if (id) {
        await deletePortMapInventory(id).then(res => {
          this.$message.success(res.message)
        })
      }
      this.refresh = !this.refresh
    },
    uploadConfirm () {
      this.refresh = !this.refresh
    }
  }
}
</script>
